/**
 * Appels réseau du module « Requêtes ».
 * Lectures : copie gardée dans l'appareil (consultation hors ligne).
 * Écritures : EN LIGNE SEULEMENT (jamais mises en file) — message clair sans réseau.
 */
import i18n from '../../i18n';
import { apiGet, apiPatch, apiPost, apiPut } from '../../utils/api';
import { apiGetAvecCopie, enLigneSeulement } from '../../services/offlineService';

const horsLigne = () => i18n.t('horsLigne.actionEnLigneSeulement');

export const lireRequetes = (slug, userId, params = '') => apiGetAvecCopie(slug, userId, `/requetes${params}`);
export const lireRequete = (slug, userId, id) => apiGetAvecCopie(slug, userId, `/requetes/${id}`);
// Compteurs et catégories par type d'actif (véhicule par défaut : adresses inchangées).
export const lireCompteurs = (slug, userId, actifType = 'vehicule') => apiGetAvecCopie(
  slug, userId, actifType === 'vehicule' ? '/requetes/compteurs' : `/requetes/compteurs?actif_type=${actifType}`);
export const lireConfigRequetes = (slug, userId, actifType = 'vehicule', actifId = null) => apiGetAvecCopie(
  slug, userId, actifType === 'vehicule' && !actifId ? '/requetes/categories'
    : `/requetes/categories?actif_type=${actifType}${actifId ? `&actif_id=${actifId}` : ''}`);

/** Catégories de chaque type d'actif : { vehicule: [...], equipement: [...], epi: [...], point_eau: [...] }. */
export const lireCategoriesParType = async (slug, userId) => {
  const types = ['vehicule', 'equipement', 'epi', 'point_eau'];
  const reponses = await Promise.all(types.map((type) => lireConfigRequetes(slug, userId, type).catch(() => null)));
  const parType = {};
  types.forEach((type, i) => { parType[type] = (reponses[i] && reponses[i].categories) || []; });
  return parType;
};

export const creerRequete = enLigneSeulement((slug, corps) => apiPost(slug, '/requetes', corps), horsLigne);
export const commenterRequete = enLigneSeulement(
  (slug, id, corps) => apiPost(slug, `/requetes/${id}/commentaires`, corps), horsLigne);
export const modifierRequete = enLigneSeulement(
  (slug, id, corps) => apiPatch(slug, `/requetes/${id}`, corps), horsLigne);
export const fermerRequete = enLigneSeulement(
  (slug, id, corps) => apiPost(slug, `/requetes/${id}/fermer`, corps), horsLigne);
export const rouvrirRequete = enLigneSeulement(
  (slug, id, corps) => apiPost(slug, `/requetes/${id}/rouvrir`, corps), horsLigne);
export const creerReparation = enLigneSeulement(
  (slug, vehiculeId, corps) => apiPost(slug, `/actifs/vehicules/${vehiculeId}/reparations`, corps), horsLigne);

export const lireConfigParametres = (slug) => apiGet(slug, '/actifs/configuration-requetes');
export const enregistrerConfigParametres = enLigneSeulement(
  (slug, corps) => apiPut(slug, '/actifs/configuration-requetes', corps), horsLigne);

export const messageErreur = (e, t) => (e && (e.hors_ligne ? e.message : (e.data?.detail || e.message)))
  || t('requetes.erreur');

/** Réduit une photo (côté le plus long 1600 px, JPEG 0,8) → data URI. */
export const lirePhoto = (fichier) => new Promise((resolve, reject) => {
  const lecteur = new FileReader();
  lecteur.onerror = () => reject(new Error('lecture'));
  lecteur.onload = () => {
    const img = new Image();
    img.onerror = () => resolve(lecteur.result);
    img.onload = () => {
      const max = 1600;
      const ratio = Math.min(1, max / Math.max(img.width, img.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(img.width * ratio);
      canvas.height = Math.round(img.height * ratio);
      const ctx = canvas.getContext('2d');
      if (!ctx) { resolve(lecteur.result); return; }
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL('image/jpeg', 0.8));
    };
    img.src = lecteur.result;
  };
  lecteur.readAsDataURL(fichier);
});
